import { render } from "./UserSmallCard.vue?vue&type=template&id=6cf09d4c"
import script from "./UserSmallCard.vue?vue&type=script&lang=js"
export * from "./UserSmallCard.vue?vue&type=script&lang=js"
script.render = render

export default script